import type { FaireProductEntity } from "../../entity_types/product";

export const p_pfj295r34u: FaireProductEntity = {
  token: "p_pfj295r34u",
  type: "product",
  name: "Moroccan Beldi Glassware - Green",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/6db8787e228eb20984373d0a9662369b4d4dae6a4a9766007a4ed94b09e3c4b0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/408fb0124fc6e6292d300d96aa17279ad571173e1356361006f13795070f8213.jpeg",
    "https://cdn.faire.com/fastly/b7ca2f0eb5d7001316509ed3e270949bc02edac6f7088808fb17dda0129066af.jpeg",
    "https://cdn.faire.com/fastly/bb2296dfa4aae1f7b3c11e72c1713939345bb60591b8e02e83af81183e0c677c.jpeg",
    "https://cdn.faire.com/fastly/84c22145cc75956a05179ff15283753c226e0c82bfbdeeae04480afea1c02438.jpeg",
    "https://cdn.faire.com/fastly/c00d7f9850c9abdf48bb1054946f07750ecee6ced09f47722f1ddd75dfdb2117.jpeg",
  ],
  priceDollars: 4.2,
  description:
    "**Packaged in sets of 6** - 24 single glasses in a master\n\nMade from recycled beer and wine bottles, these sets are a second act for glass that would otherwise be sent to landfills. Fun fact: The top-selling beer in Morocco is Heineken, whose iconic green bottles give our green glasses their distinctive shade.\n\nOur Moroccan glassware sets come in four distinct shades. The handblown construction is evident in the bubbles suspended in the glass itself, and the organic forms that the vessels take. Even better, these lovely glasses stack - saving space or to make room for lots and lots of them.\n\nCare - Dishwasher safe, but please note: handblown glass is sensitive to drastic temperature changes.\n\nPackaged in sets of 6 in traditional Moroccan gift packaging.\n\nDims: 5'' tall x 2'' base diameter x 3'' top diamater, 11 fl oz ",
  tags: [],
  msrpDollars: 8.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:53.616Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
